<template>
  <!-- && active != 'User' 这个条件特殊处理，页面需要到达底部 让遮罩挡住底部tab -->
  <div id="app" :class="{ 'pt-0': $route.meta.titleType == 'noTitle' }" safe-area-inset-top>
    <!-- 标题 -->
      <!-- 首页特殊处理 -->
    <!-- <van-nav-bar ref="navBar" id="navBar" fixed :title="$route.meta.title" v-if="$route.meta.titleType != 'noTitle'">
      <template #left v-if="$route.meta.titleType == 'home'">
        <img class="icon-logo" alt="logo" src="./assets/logo.png">
      </template>

      <template #left v-else-if="$route.meta.titleType != 'noBack'">
        <i class="icon-back" @click="onBack()"></i>
      </template>

      <template #right v-if="$route.meta.titleType == 'home'">
        <span class="search-box" @click="$router.push('/goods/list?type=4')">搜索</span>
      </template>
    </van-nav-bar> -->

    <!-- 页面 -->
    <KeepAlive>
      <router-view v-if="$route.meta.keepAlive == true" :key="$route.path" />
    </KeepAlive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.path" />

    <!-- 底部tabbar -->
    <!-- <van-tabbar v-model="active" v-if="$route.meta.tabbar" id="homeTabbar">
      <van-tabbar-item :name="item.name" v-for="item, index in tabList" :key="index" replace :to="item.url"
        :badge="item.badge">
        <span>{{ item.title }}</span>
        <template #icon="props">
          <img :src="require(`${props.active ? item.active : item.inactive}`)" />
        </template>
      </van-tabbar-item>
    </van-tabbar> -->

    <!-- 回到顶部 -->
    <!-- <img class="to-top" @click="scrollToTop" :class="{ 'b-134': !$route.meta.tabbar, 'b-172': $route.meta.tabbar }"
      src="https://xhdata.wan4.com/wsw-h5-27.png" :style="`display:${showToTop ? 'block' : 'none'};`" /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 'Home',
      showToTop: false,
      tabList: [
        {
          title: '首页',
          name: 'Home',//对应route 中配置的 name
          inactive: './assets/icon/icon-tab-home.png',
          active: './assets/icon/icon-tab-home-active.png',
          url: '/',
          badge: '',
        },
        {
          title: '分类',
          name: 'ClassifyList',//对应route 中配置的 name
          inactive: './assets/icon/icon-tab-class.png',
          active: './assets/icon/icon-tab-class-active.png',
          url: '/goods/classifyList',
          badge: '',
        },
        {
          title: '采购车',
          name: 'Cart',//对应route 中配置的 name
          inactive: './assets/icon/icon-tab-cart.png',
          active: './assets/icon/icon-tab-cart-active.png',
          url: '/goods/cart',
          badge: '',
        },
        {
          title: '我的',
          name: 'User',//对应route 中配置的 name
          inactive: './assets/icon/icon-tab-user.png',
          active: './assets/icon/icon-tab-user-active.png',
          url: '/user',
          badge: '',
        }
      ]
    }
  },
  watch: {
    // 监听路由发生改变
    '$route': {
      handler(newVal) {
        if (newVal) {
          this.active = newVal.name;
          if (this.tabList.filter(a => a.name == newVal.name).length > 0) {
            this.getCartNum();
          }
        }
      }
    },
    '$store.state.cartNum': {
      handler(val) {
        this.tabList[2].badge = val || '';
      }
    }
  },
  mounted() {
    document.title = '万饰网'
    // 监听滚动事件
    window.onscroll = () => {
      // 获取滚动条当前的位置
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > window.innerHeight) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
    }
    this.getCartNum();
  },
  methods: {
    onBack() {
      if (window.history.length <= 1) {
        this.$router.replace('/')
      } else {
        this.$router.back()
      }
    },
    getCartNum() {
      this.$ajax('/iap-api/wan4/presonal/cart/myCartCount.do', {}).then(res => {
        let cartNum = res.data.catCount == 0 ? '' : res.data.catCount;
        this.$store.commit('setCartNum', cartNum);
        this.tabList[2].badge = this.$store.state.cartNum;
        if (res.data.searchKey) {
          this.$store.commit('setSearchKey', res.data.searchKey.split(','))
        } else {
          this.$store.commit('setSearchKey', [])
        }
      })
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      // document.getElementById('app').scrollTo();
    },

  }
}
</script>

<style lang="less">
@import './normalize.css';
@import './assets/css/vant';

* {
  font-family: Pingfang SC, PingFangSC-Regular, miui, Hiragino Sans GB, Noto Sans, Microsoft YaHei;
  box-sizing: border-box;
}


body,
html {
  background: #F4F4F4;
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.pt-0 {
  padding-top: 0px !important;
}

.b-134 {
  bottom: calc(134px + env(safe-area-inset-bottom));
}

.b-172 {
  bottom: calc(300px + env(safe-area-inset-bottom));
}

.to-top {
  position: fixed;
  right: 32px;
  width: 94px;
  height: 94px;
  z-index: 1000;
}


.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/*两行 */
.two-line {
  display: -webkit-box;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}


.icon-back {
  width: 48px;
  height: 48px;
  background: url('./assets/icon/icon-back.png') no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}

.icon-logo {
  width: 196px;
  margin-left: 18px;
}

.search-box {
  width: 172px;
  height: 68px;
  border-radius: 99px;
  border: 2px solid #DCDCDC;
  background: #F4F4F4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;

  &::before {
    content: '';
    width: 40px;
    height: 40px;
    background: url('./assets/icon/icon-search.png') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    margin-right: 8px;
  }
}
</style>
